export { default as MainProduct } from './MainProduct';
